import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { useSelector } from "react-redux";
import identitySelectors from "../../selectors/identity";
import { Message } from "semantic-ui-react";
import _, { compact } from "lodash";
import { Link } from "react-router-dom";

export function RegisterFailureMessage({ email, forgotPasswordPath }: { email: string; forgotPasswordPath: string }) {
  const query = queryString.parse(window.location.search) as {
    redirect?: string;
    authErr?: string;
  };
  const [queryError, setQueryError] = useState("");
  const postSignup = useSelector(identitySelectors.postSignup);
  const err = compact([query.authErr, null]);
  useEffect(() => {
    setQueryError(query.authErr as string);
  }, []);

  const signupFailureMessages = [
    _.get<string[]>(postSignup, "error.response.message", ["We were unable to log you in"]).concat(err),
  ].flat();
  // Custom error message for email address in use
  if (signupFailureMessages.some((msg) => msg.includes("Email address is in use"))) {
    return (
      <Message className='feedback' negative aria-live='polite'>
        User name &apos;{email}&apos; is already in use. Please try a different user name or{" "}
        <Link to={forgotPasswordPath}>Reset Your Password</Link>
      </Message>
    );
  }

  if (queryError) {
    const rest = _.omit(query, "authErr");
    const search = queryString.stringify(rest);
    window.history.replaceState({}, document.title, `${window.location.pathname}${search ? `?${search}` : ""}`);
  }
  return (
    <Message className='feedback tw-p-4 tw-pl-5' negative>
      <Message.Header className='tw-text-base tw-font-semibold tw-text-red'>Sign Up Failed</Message.Header>
      <Message.Content className='tw-text-sm'>{queryError || signupFailureMessages}</Message.Content>
    </Message>
  );
}
